import {Component, ElementRef, EventEmitter, HostListener, Input, Output} from '@angular/core';
import {isNullOrUndefined} from "util";


@Component({
    selector: 'tfl-bo-dropdown',
    template: require('./dropdown.component.html')
})
export class DropdownComponent {
    @Input() items: Item[] = [];
    @Input() title: string;
    @Output() itemSelected = new EventEmitter();

    isOpenDropdown: boolean = false;
    
    constructor(private el: ElementRef) {
    }

    @HostListener('document:click', ['$event.target'])
    onDocumentClick(targetEl) {
        if (this.isOpenDropdown && this.el) {
            if (!this.el.nativeElement.contains(targetEl)){
                this.toggleDropdownVisibility();
            }
        }
    }

    get hasAtLeastOneEnabledItem(): boolean {
        if (this.items) {
            for (let it of this.items) {
                if (!it.disabled) {
                    return true;
                }
            }
        }
        return false;
    }

    processListItemClick(it: Item) {
        // this.customChange.emit();
        if (it.disabled) {
            return;
        }
        this.toggleDropdownVisibility();
        this.itemSelected.next(it);
    }
    
    onBtnClick() {
        if (this.hasAtLeastOneEnabledItem) {
            this.toggleDropdownVisibility();
        }
    }

    private toggleDropdownVisibility(setVisible?: boolean): void {
        this.isOpenDropdown = (!isNullOrUndefined(setVisible)) ? setVisible : !this.isOpenDropdown;
    }

}

export interface Item {
    id: any;
    name: string;
    disabled: boolean;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/dropdown/dropdown.component.ts